export const apiBaseUri = process.env.REACT_APP_ADMIN_API_BASE_URL || "";
export const serverName = process.env.REACT_APP_SERVER_NAME || "";

export const svgStateDeselectedColor = "#bbb";
export const svgStateSelectedColor = "#222";

export const colorLimitReached = "#28CC2E";
export const colorOverHalfwayReached = "#FAA93F";
export const colorBelowHalfwayReached = "#FA4C3F";
